<template>
  <v-card flat class="rounded-20 pb-4" v-if="openOrders.length">
    <v-card-title class="title-font pb-0"> OSTEON ORDERS </v-card-title>
    <v-card
      outlined
      v-for="(forwardedOrder, index) in openOrders"
      :key="index"
      flat
      class="rounded-10 d-flex flex-column mx-4 mt-2"
      @click="openForwardedOrder(forwardedOrder)"
    >
      <v-sheet :color="statusBarColor(forwardedOrder)" class="py-1" dark>
        <span class="px-4 font-weight-medium">
          {{ statusBarText(forwardedOrder) }}
        </span>
      </v-sheet>
      <v-card-title class="title-font pb-0">
        <v-icon size="30" class="mr-2">
          {{ determineIconFromProduct(forwardedOrder.product) }}
        </v-icon>
        {{ toTitleCase(forwardedOrder.product) }}
        <v-chip label small color="primary" class="px-1 ml-2">
          {{ sessionName(forwardedOrder.session_uid) }}
          <v-icon size="30" class="ml-2">
            {{
              sessionDentate(forwardedOrder.session_uid) === "upper"
                ? "$singlearchDark"
                : "$lowerarchDark"
            }}
          </v-icon>
        </v-chip>
      </v-card-title>

      <v-row>
        <v-col cols="6" class="pr-0">
          <v-list dense>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title> OSTEON CASE REFERENCE </v-list-item-title>
                <v-list-item-subtitle>
                  {{ forwardedOrder.case_details[0].case_mkey }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title> STATUS </v-list-item-title>
                <v-list-item-subtitle>
                  {{ forwardedOrder.case_details[0].status }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="forwardedOrder.case_details[0].dispatch">
              <v-list-item-content>
                <v-list-item-title> COURIER </v-list-item-title>
                <v-list-item-subtitle>
                  {{ forwardedOrder.case_details[0].dispatch.courier }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
        <v-col cols="6" class="pl-0">
          <v-list dense>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title> SUBMITTED </v-list-item-title>
                <v-list-item-subtitle>
                  {{
                    forwardedOrder.submitted_at
                      | luxon({ output: "date_short" })
                  }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <template v-if="forwardedOrder.case_details[0].dispatch">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title> DISPATCHED DATE </v-list-item-title>
                  <v-list-item-subtitle>
                    {{
                      forwardedOrder.case_details[0].dispatch.dispatched_at
                        | luxon({ output: "date_short" })
                    }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title> TRACKING REFERENCE </v-list-item-title>
                  <v-list-item-subtitle>
                    {{
                      forwardedOrder.case_details[0].dispatch.tracking_reference
                    }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </v-col>
      </v-row>
    </v-card>
  </v-card>
</template>

<script>
import { toTitleCase, determineIconFromProduct } from "@/utils"
import { mapGetters } from "vuex"

export default {
  name: "OpenForwardedOrders",

  computed: {
    ...mapGetters(["orderForwardedOrders", "selectedOrder"]),

    openOrders() {
      return (
        this.orderForwardedOrders
          ?.filter((o) => !!o.submitted_at)
          .sort(
            (a, b) =>
              new Date(a.created_at).getTime() -
              new Date(b.created_at).getTime()
          ) || []
      )
    }
  },

  methods: {
    toTitleCase,

    determineIconFromProduct,

    openForwardedOrder(forwardedOrder) {
      this.$emit("openOrder", forwardedOrder)
    },

    sessionName(sessionUid) {
      return toTitleCase(
        this.selectedOrder.sessions.find((s) => s.uid === sessionUid)
          .session_type
      )
    },

    sessionDentate(sessionUid) {
      return this.selectedOrder.sessions.find((s) => s.uid === sessionUid)
        .dentate
    },

    forwardedOrderCompleted(forwardedOrder) {
      if (
        forwardedOrder.product === "DESIGN" &&
        forwardedOrder.has_return_files
      )
        return true
      if (forwardedOrder.case_details.every((c) => c.status === "Dispatched"))
        return true
      return false
    },

    statusBarColor(forwardedOrder) {
      if (this.forwardedOrderCompleted(forwardedOrder)) return "success"
      return "primary"
    },
    statusBarText(forwardedOrder) {
      if (this.forwardedOrderCompleted(forwardedOrder)) return "Complete"
      return "In Progress"
    }
  }
}
</script>
